import { IPrescription } from "@curefit/care-common";
declare var socket: any;

export default class SocketIOUtils {
    static savePrescription(consultationId: number, prescription: IPrescription) {
        if (typeof socket !== "undefined") socket.emit("savePrescription");
    }

    static deletePrescription(consultationId: number) {
        if (typeof socket !== "undefined") socket.emit("deletePrescription", consultationId);
    }
}